import { Link } from "react-router-dom";
import { Card, CardBody, Col } from "reactstrap";
import { H3, Image, P } from "../../../AbstractElements";
import { AddProducts, GoodMorning, WadeWarren } from "../../../Constant";
import { ADD_PRODUCT_DATA } from "../../../Data/Dashboard";
import { dynamicImage } from "../../../Service/DynamicImage";

const AddProduct = () => {
  return (
    <Col xl="6" sm="12" className="box-col-5">
      <Card className="p-0 profile-greeting">
        <CardBody className="wadewarren">
          <div className="img-overlay">
            <H3>{GoodMorning},</H3>{WadeWarren}
            <P>Here’s what’s happenin with your store today. See the statistics at once</P>
            <Link className="btn" to={`${process.env.PUBLIC_URL}/ecommerce/product`}>
              <i className="icofont icofont-plus"> </i>{AddProducts}
            </Link>
          </div>
          <ul className="list-unstyled confetti simple-list">
            {ADD_PRODUCT_DATA.map((item, index) => (
              <li key={index} className="bg-box">
                <Image src={dynamicImage(`dashboard-2/${item}`)} alt="" />
              </li>
            ))}
          </ul>
        </CardBody>
      </Card>
    </Col>
  );
};

export default AddProduct;
